import { z } from 'zod';
import type { SmsTemplateToken } from '@sleed/bizcommerce-api';

/**
 * SMS/Viber template edit form. Mirrors `SmsTemplateToken` and the legacy admin grid
 * (Core/client/admin/src/pages/System/SmsTemplates/index.js): cd required ≤50, channel
 * (0=Sms, 1=Viber), bd (body) required, si required. Viber fields apply when channel=Viber.
 */
export const smsTemplateSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	channel: z.number().int(),
	bd: z.string().trim().min(1, 'validation.required'),
	si: z.number({ message: 'validation.required' }).int(),
	iv: z.boolean(),
	viberImageUrl: z.string().nullable(),
	viberActionUrl: z.string().nullable(),
	viberActionText: z.string().nullable()
});

export type SmsTemplateFormValues = z.infer<typeof smsTemplateSchema>;

export const EMPTY_SMS_TEMPLATE: SmsTemplateFormValues = {
	cd: '',
	channel: 0,
	bd: '',
	si: 0,
	iv: true,
	viberImageUrl: null,
	viberActionUrl: null,
	viberActionText: null
};

export function tokenToForm(token: SmsTemplateToken): SmsTemplateFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		channel: token.channel ?? 0,
		bd: token.bd ?? '',
		si: token.si ?? 0,
		iv: token.iv ?? false,
		viberImageUrl: token.viberImageUrl ?? null,
		viberActionUrl: token.viberActionUrl ?? null,
		viberActionText: token.viberActionText ?? null
	};
}

export function formToToken(form: SmsTemplateFormValues): SmsTemplateToken {
	return {
		id: form.id,
		cd: form.cd.trim(),
		channel: form.channel,
		bd: form.bd,
		si: form.si,
		iv: form.iv,
		viberImageUrl: form.viberImageUrl,
		viberActionUrl: form.viberActionUrl,
		viberActionText: form.viberActionText
	};
}
